import { useSelector, useDispatch } from 'react-redux'
import { RootState } from "../../../../setup/redux/RootReducer";
import { setProductDetail } from '../redux/ProductDetailSlice'
import { setCurrentStore } from '../redux/CurrentStoreSlice'
import { ProductDetail} from '../models/productServiceModels'




export default function StoreChange() {
    const currentStore = useSelector((state: RootState) => state.currentStoreReducer);
    const productListArray = useSelector((state: RootState) => state.productListReducer);
    const dispatch = useDispatch();


    const changeStore = () => {
        dispatch(setCurrentStore({ storeNo: 0, storeName: "" }));
        dispatch(setProductDetail(new ProductDetail()));

    }
return(
    <div style={{ position: "absolute", top: "5px", left: "2%" }}>
                    <span className='badge badge-primary' style={{ padding: "1em" }}>
                        Seçili mağaza: {currentStore.store.storeName.split(">")[1]}
                    </span>
                    <span onClick={() => changeStore()} style={{ textDecorationLine: "underline", marginLeft: "5%", fontSize: "14px", position: "absolute", bottom: 0, cursor: 'pointer' }}>
                        Değiştir
                    </span>
                </div>
)
}